import { c as _c } from "react/compiler-runtime";
import { Footer } from "@repo/ui/components/brand/Footer";
import { jsx as _jsx } from "react/jsx-runtime";
const quickLinks = [{
  name: "Hem",
  href: "/"
}, {
  name: "Upplevelser",
  href: "/upplevelser"
}, {
  name: "Användarvillkor",
  href: "/om/villkor"
}, {
  name: "Integritetspolicy",
  href: "/om/integritet"
}];
export default function SiteFooter() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(Footer, {
      quickLinks: {
        title: "Snabbl\xE4nkar",
        links: quickLinks
      },
      theme: {
        bgColor: "bg-gradient-to-b from-gray-900/25 via-gray-900/25 to-gray-900",
        textColor: "text-gray-400",
        hoverColor: "text-[#ff4d4d]",
        logoVariant: "full",
        logoClassName: "w-full"
      },
      className: "py-12 md:py-16"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}